// extracted by mini-css-extract-plugin
export default {"mag_home_banners_container":"banners-tab_mag_home_banners_container__Aj2Wx"};